import { useState, useEffect } from "react";
import { Music, Trash2, Upload } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function AdminSettings() {
  const [info, setInfo] = useState(null);
  const [uploading, setUploading] = useState(false);
  const load = () => api.get("/soundtrack/info").then((r) => setInfo(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const onFile = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    if (f.size > 25 * 1024 * 1024) { toast.error("File troppo grande (max 25MB)"); return; }
    const fd = new FormData();
    fd.append("file", f);
    setUploading(true);
    try { await api.post("/admin/soundtrack", fd, { headers: { "Content-Type": "multipart/form-data" } }); toast.success("Colonna sonora caricata"); load(); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setUploading(false); e.target.value = ""; }
  };
  const remove = async () => {
    if (!window.confirm("Rimuovere la colonna sonora?")) return;
    try { await api.delete("/admin/soundtrack"); toast.success("Rimossa"); load(); } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };

  return (
    <div className="max-w-2xl" data-testid="admin-settings">
      <div className="glass rounded-2xl p-7">
        <div className="flex items-center gap-3 mb-2"><Music size={18} className="text-gold" /><h3 className="font-display text-2xl text-[#2A1F14]">Colonna sonora Lux Aeterna</h3></div>
        <p className="text-[#2A1F14]/55 text-sm leading-relaxed mb-6">Musica in loop nelle pagine Tema Natale e Quiz. Parte al primo tocco dell'utente (i browser bloccano l'autoplay) e ricorda la preferenza. Formati: mp3, m4a, ogg · max 25MB.</p>
        {info?.available ? (
          <div className="flex items-center justify-between border border-[#2A1F14]/10 rounded-xl px-5 py-4 mb-4" data-testid="soundtrack-current">
            <div><p className="text-[#2A1F14] text-sm">{info.filename}</p><p className="text-[#2A1F14]/45 text-xs">{(info.size / 1024 / 1024).toFixed(1)} MB · attiva</p></div>
            <div className="flex items-center gap-4">
              <audio controls src={`${process.env.REACT_APP_BACKEND_URL}/api/soundtrack`} className="h-8" />
              <button onClick={remove} data-testid="soundtrack-delete" className="text-[#2A1F14]/40 hover:text-rose-500"><Trash2 size={16} /></button>
            </div>
          </div>
        ) : <p className="text-[#2A1F14]/45 text-sm mb-4" data-testid="soundtrack-empty">Nessuna traccia caricata: il pulsante musica resta nascosto.</p>}
        <label className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-gold text-black text-sm font-medium cursor-pointer hover:bg-[#D4A056] transition-colors ${uploading ? "opacity-50 pointer-events-none" : ""}`}>
          <Upload size={15} /> {uploading ? "Caricamento…" : info?.available ? "Sostituisci traccia" : "Carica traccia"}
          <input type="file" accept="audio/*" className="hidden" onChange={onFile} data-testid="soundtrack-file" />
        </label>
      </div>
    </div>
  );
}
